import { useState, useEffect } from "react";
import { Modal, Button, Card } from "react-bootstrap";
import axios from "axios";
import toastr from "toastr";
import { CustomDropdown } from "components/CustomDropdown";
import { Line } from "ktm-ui";

const EditIndividualEmpFixedCampaignModal = ({
    showEditIndividualEmpFixedCampaignModal,
    bencatOptions,
    closeEditIndividualEmpFixedCampaignModal,
    employee,
    policyId
}) => {
    const [selectedBenCat, setSelectedBenCat] = useState(null);
    const [newSalaryMoney, setNewSalaryMoney] = useState(employee.salaryMoney || 0);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (!employee || !bencatOptions?.length) return;

        const current = bencatOptions.find(b => b.name === employee.name) || bencatOptions[0];
        setSelectedBenCat(current);
        setNewSalaryMoney(employee.salaryMoney ?? 0);
    }, [employee, bencatOptions]);

    const handleSave = async () => {
        if (!selectedBenCat) {
            toastr.error("Please select a benefit category");
            return;
        }

        setSaving(true);

        try {
            const body = {
                PolicyId: policyId,
                EmployeeId: employee.id,
                SelectedBenCatId: selectedBenCat.id,
                NewSalaryMoney: newSalaryMoney
            };

            const response = await axios.put(
                "/api/Flex/updateindividualemployeecampaign",
                body
            );

            if (response.data.success) {
                toastr.success("Employee campaign updated successfully");
                closeEditIndividualEmpFixedCampaignModal();
            } else {
                toastr.error(response.data.message ?? "Update failed");
            }
        } catch {
            toastr.error("Failed to update employee campaign");
        } finally {
            setSaving(false);
        }
    };

    const handleSalaryChange = (e) => {
        const value = e.target.value.replace(/[^0-9.]/g, '');
        setNewSalaryMoney(parseFloat(value));
    };

    console.log("Selected BenCat:", selectedBenCat);

    const showSalaryField =
        employee.creditCalcMethod === "SALARY" ||
        selectedBenCat?.creditCalcMethod === "SALARY";

    return (
        <Modal
            show={showEditIndividualEmpFixedCampaignModal}
            onHide={closeEditIndividualEmpFixedCampaignModal}
            backdrop="static"
            className="edit-employee-campaign-modal-container"
        >
            <Modal.Header className="campaign-edit-employee-modal-header">
                <Modal.Title>Edit Employee New Year Benefit</Modal.Title>
            </Modal.Header>

            <Modal.Body className="campaign-edit-employee-modal-body">
                <Card>
                    <Line>
                        <div className="RT-Static-Field" style={{ marginLeft: 10 }}>
                            <label className="RT-Static-Field__label">
                                Employee Name
                            </label>
                            <div className="RT-Static-Field__content" style={{ fontWeight: "bold" }}>
                                {employee.lastName}, {employee.firstName}
                            </div>
                        </div>
                    </Line>

                    <Line>
                        <div className="RT-TextBox">
                            <label className="RT-Label">Benefit Category</label>
                            <CustomDropdown
                                options={bencatOptions.map(b => b.name)}
                                selectedOption={selectedBenCat?.name}
                                setSelectedOption={(name) =>
                                    setSelectedBenCat(
                                        bencatOptions.find(b => b.name === name)
                                    )
                                }
                            />
                        </div>
                    </Line>

                    {showSalaryField && (
                        <Line>
                            <div className="form-group" style={{ marginLeft: 10, width: '50%' }}>
                            <label htmlFor="limit">Salary</label>
                            <div className="input-group" style={{ width: 250, height: 35 }}>
                                <span className="input-group-text">$</span>
                                <input
                                type="number"
                                className="form-control"
                                id="limit"
                                value={newSalaryMoney}
                                onChange={handleSalaryChange}
                                />
                            </div>
                            </div>
                        </Line>
                    )}
                </Card>
            </Modal.Body>

            <Modal.Footer className="campaign-edit-employee-modal-footer">
                <Button
                    variant="secondary"
                    onClick={closeEditIndividualEmpFixedCampaignModal}
                    disabled={saving}
                >
                    Cancel
                </Button>

                <Button
                    variant="primary"
                    onClick={handleSave}
                    disabled={saving}
                >
                    {saving ? "Saving..." : "Save"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditIndividualEmpFixedCampaignModal;
